const PaymentInitComponent = () => import("@/views/payment/paymentInit.vue");

export default {
    path: "payment",
    meta: { label: "Payment" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "init/:id",
                    name: "Payment Init",
                    meta: {
                        hideLayout: true,
                    },
                    component: PaymentInitComponent,
                }
            ],
        },
    ],
};